import { render, staticRenderFns } from "./ModalNavigationMenu.vue?vue&type=template&id=3a3651ce&scoped=true&"
import script from "./ModalNavigationMenu.vue?vue&type=script&lang=js&"
export * from "./ModalNavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./ModalNavigationMenu.vue?vue&type=style&index=0&id=3a3651ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3651ce",
  null
  
)

export default component.exports